import type {
  CommonResponsePasswordRequiredResponse,
  GenerateStudentImpersonationAuthTokenByData,
  GetSwitchCandidatesData,
  LoginResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type LoginInfo,
  LoginInfoSchema,
  type LoginSession,
  LoginSessionSchema,
  type StudentImpersonationAuthToken,
  StudentImpersonationAuthTokenSchema,
  type TeacherSwitchCandidates,
  TeacherSwitchCandidatesSchema,
} from './schemas'

export const adaptLoginInfo = (raw: CommonResponsePasswordRequiredResponse['data']): LoginInfo =>
  parseApiResponse(LoginInfoSchema, raw, 'LoginInfo')

export const adaptLoginSession = (raw: LoginResponse): LoginSession =>
  parseApiResponse(LoginSessionSchema, raw, 'LoginSession')

export const adaptTeacherSwitchCandidates = (
  raw: GetSwitchCandidatesData,
): TeacherSwitchCandidates =>
  parseApiResponse(TeacherSwitchCandidatesSchema, raw, 'TeacherSwitchCandidates')

export const adaptStudentImpersonationAuthToken = (
  raw: GenerateStudentImpersonationAuthTokenByData,
): StudentImpersonationAuthToken =>
  parseApiResponse(StudentImpersonationAuthTokenSchema, raw, 'StudentImpersonationAuthToken')
